<template>
<div class="report">
    <top-nav></top-nav>

    <page-title :title="getText('audit_report_configuration_title')" icon="reports"></page-title>
    <div v-if="dataLoaded">
      <div class="actions-bar sticky">
          <div class="container">
              <div class="action-wrapper">
                  <el-button class="greenButton" @click="chooseEngines()">{{ getText('audit_report_configuration_choose_engine_button') }}</el-button>
                  <el-button v-loading="loadingSave" class="greenButton" :class="{'disabled': auditReportFailed}" @click="saveReport()"><img class="save-icon" src="/static/img/save-icon.svg" alt="save icon">{{ getText('audit_report_configuration_save') }}</el-button>
                  <el-button class="greenButton" :class="{'disabled': auditReportFailed}" @click="overrideValues()">{{ getText('audit_report_override_values_button') }}</el-button>
              </div>
              <div class="action-wrapper">
                  <el-button class="whiteButton" @click="$router.push({'name': 'moteurs', 'params': {'siteid': $route.params.auditId}})">{{ getText('audit_report_config_modal_return_button') }}</el-button>
                  <el-button v-loading="loadingSaveTriggerGenerate" class="greenButton" :class="{'disabled': auditReportFailed}" icon="el-icon-download" @click="generateReport">{{ getText('audit_report_download') }}</el-button>
              </div>
          </div>
      </div>
      <div class="content" v-if="showPdfs === true">
          <div :key="userData.length">
              <pdf-viewer
                  ref="pdf-viewer"
                  v-for="item in orderedPages"
                  :key="item.page + '-' + item.index"
                  :item="item"
                  :user-data="userData"
                  :audit-data="auditReport.audit_data"
                  :user-data-already-setted="userDataAlreadySetted"
                  @add-page="addPage"
              ></pdf-viewer>
          </div>
      </div>
<!--     <div v-else class="no-content">
        <h1>Choisir un moteur pour lancer la génération du pdf</h1>
    </div> -->
      <div v-else class="generating-report">
          <p v-if="auditReportFailed" class="message">{{ getText('audit_report_generation_error_message') }}</p>
          <p v-else class="message">{{ getText('audit_report_generation_waiting_message') }}</p>
      </div>
    </div>
    <div v-else>
      <div
        class="content"
        style="min-height: 200px"
        :v-loading="true"
        element-loading-text="Chargement des données en cours..."
        element-loading-spinner="el-icon-loading"
        >
      </div>
    </div>
    <page-footer></page-footer>
    <waiting-modal
        ref="waitingModal"
        :key="fieldToWatch"
        :fieldToWatch="fieldToWatch"
        :onSuccess="successCallback"
        :onError="onError"
        :isDownloadModal="isDownloadModal"
    ></waiting-modal>
    <modal-choose-engines
        ref="chooseEnginesModal"
        :modifySelection="modifySelection"
        :config="config"
        :key="config.length"
        :enableCEE="enableCEE"
        :securityCoeff="securityCoeff"
        :existingOverriddenAuditData="overriddenAuditData"
        :defaultAuditData="auditReport ? auditReport.audit_data.motors : {}"
        @sendChosenEngines="sendChosenEngines"
        @saveNewSecurityCoeff="saveNewSecurityCoeff"
    ></modal-choose-engines>
    <modale-value-override
        ref="modaleValueOverride"
        :overriddenAuditData="overriddenAuditData"
        :defaultAuditData="defaultAuditData"
        @saveNewValue="saveNewOverriddenValue"
        @sendOverriddenValues="sendOverriddenValues"
    ></modale-value-override>
</div>
</template>

<script>
import topNav from '../../ui/top-nav.vue';
import pageTitle from '../..//ui/page-title.vue';
import pageFooter from '../../ui/page-footer.vue';
import WaitingModal from './waitingModal.vue';
import {mapGetters} from 'vuex';
import pdfViewer from './pdfjs.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import modalChooseEngines from './modaleChooseEngines.vue';
import modaleValueOverride from './modaleValueOverride.vue';
import {cloneDeep} from 'lodash';

export default {

    components: {
        topNav,
        pageTitle,
        pageFooter,
        pdfViewer,
        NsLoader,
        WaitingModal,
        modalChooseEngines,
        modaleValueOverride
    },

    props: {
    },

    data: function(){
        return {
            auditReport: null,
            securityCoeff: 0,
            config: [],
            showPdfs: false,
            overriddenAuditData: {},
            defaultAuditData: {},
            userData: [],
            userDataAlreadySetted: false,
            pagesDescriptor: null,
            modifySelection: false,
            dataLoaded: false,
            fieldToWatch: 'prepare_status',
            loadingSave: false,
            loadingSaveTriggerGenerate: false,
        };
    },
    computed: {
        ...mapGetters([
            'getText',
        ]),
        auditReportFailed() {
            return this.auditReport === undefined || this.auditReport === null || Object.keys(this.auditReport).length  === 0;
        },
        successCallback() {
            if (this.isDownloadModal) {
                return this.downloadReport;
            } else {
                return this.onAudditReportReady;
            }
        },
        enableCEE(){
            if(
                this.auditReport &&
                this.auditReport.audit_data &&
                this.auditReport.audit_data.cee !== undefined
            ){
              return true;
            }
            return false;
        },
        orderedPages (){
            if(this.pagesDescriptor){
                return this.pagesDescriptor.slice().sort((a,b) => {
                    return a.index - b.index;
                });
            }
            return [];
        },
        isDownloadModal() {
            return this.fieldToWatch === 'generate_status';
        },
        currentReportUrl(){
          return `${window.config.api_root_url}/${this.$store.state.api.meta.listModels.auditReports.url}${this.$route.params.reportId}/`;
        }
    },
    mounted (){
        window.addEventListener('resize', this.handleResize);
        this.$eventBus.$on('text-updated', (data) => {
            this.userData[data.pageIndex].data[data.fieldName] = data.text;
        });
        this.$eventBus.$on('display-updated', (data) => {
            this.userData[data.pageIndex].display = data.display;
        });
        if (this.$route.params.reportId === undefined) {
            this.$refs.chooseEnginesModal.open(true);
            this.dataLoaded = true;
        } else {
            this.$nextTick(this.loadData);
        }
    },
    beforeDestroy(){
        this.$eventBus.$off('text-updated');
        this.$eventBus.$off('display-updated');
    },

    methods: {
        async loadData(){
            let existingReport = await this.$store.dispatch('remoteGet', {
              url: this.currentReportUrl
            });
            if(existingReport.prepare_status == 'COMPLETED'){
              this.onAudditReportReady({data: existingReport}, false);
            }
            else{
              if(existingReport.prepare_status == 'FAILED'){
                await this.retryPrepareReport();
              }
              this.fieldToWatch = 'prepare_status';
              this.watchAuditReport(this.$route.params.reportId);
            }
            this.dataLoaded = true;
        },
        async retryPrepareReport(){
            return await this.$store.dispatch('patchItem', {
                item: {
                    uid: this.$route.params.reportId,
                    url: this.currentReportUrl,
                    prepare_status: 'PENDING',
                },
                model: 'auditReports',
            });
        },
        saveNewSecurityCoeff(value) {
            this.securityCoeff = parseFloat(value);
        },
        async generateReport() {
            this.loadingSaveTriggerGenerate = true;
            this.fieldToWatch = 'generate_status';
            try{
              await this.saveReport();
              await this.$store.dispatch('patchItem', {
                  item: {
                      uid: this.auditReport.uid,
                      url: this.auditReport.url,
                      generate_status: 'PENDING',
                  },
                  model: 'auditReports',
              });
              this.watchAuditReport(this.auditReport.uid);
            }
            catch(e){
              console.error(e);
              this.$notify.error({
                  message: `Erreur lors de la génération du rapport : ${e}`
              });
            }
            this.loadingSaveTriggerGenerate = false;
        },
        downloadReport(response) {
            this.$set(this, 'auditReport', response.data);
            this.$refs.waitingModal.resetData
        },
        handleResize (){
            if(this.$refs['pdf-viewer']){
                for(let item of this.$refs['pdf-viewer']){
                    item.handleResize();
                }
            }
        },
        saveNewOverriddenValue(payload) {
            this.overriddenAuditData[payload.motor].solutions_table[payload.solutionIndex][payload.overridableKey] = payload.value;
        },
        overrideValues() {
            this.$confirm(this.getText('audit_report_value_override_warning_confirm_text'), this.getText('audit_report_warning_confirm_title'), {
                confirmButtonText: this.getText('audit_report_warning_confirm_validate_button'),
                cancelButtonText: this.getText('audit_report_warning_confirm_cancel_button'),
                cancelButtonClass: 'whiteButton',
                confirmButtonClass: 'greenButton'
            }).then(() => {
                this.modifySelection = true;
                this.$refs.modaleValueOverride.open();
            });
        },
        chooseEngines() {
            this.modifySelection = true;
            this.$refs.chooseEnginesModal.open(false);
        },
        addPage (index){
            let current_page = this.pagesDescriptor[index]
            let motorName = null;
            if (index === this.pagesDescriptor.length || !current_page.motor_name){
                motorName = null;
            } else {
                motorName = current_page['motor_name'];
            }
            let pageName = `custom_page_${this.pagesDescriptor.filter((page) => page.pdf_template === null).length +1}`;
            let pageDescriptor = {
                index: index+1,
                background_file: null,
                pdf_template: null,
                page: pageName,
                motor_name: motorName,
                display: true,
                text_zones: {
                    title: {
                        style: ['title'],
                        x: 17,
                        y: 27.5,
                        w: 263,
                        h: 16.2,
                        name: 'titre',
                        default: 'titre',
                        text: '',
                    },
                    sub_title: {
                        style: ['sub-title'],
                        x: 17,
                        y: 38,
                        w: 263,
                        h: 12,
                        name: 'sous-titre',
                        default: 'sous titre',
                        text: '',
                    },
                    text: {
                        style: ['text'],
                        x: 17,
                        y: 56,
                        w: 263,
                        h: 137,
                        name: 'message',
                        default: 'message',
                        text: '',
                    },
                },
            }
            this.userData.splice(
                index+1,
                0,
                {
                    // page_name: pageName,
                    data: {
                        title: 'titre',
                        sub_title: 'sous-titre',
                        text: 'message',
                    },
                    display: true,
                    motor_name: motorName,
                    index: index+1
                }
            );

            this.userData.forEach((data, index) => {
                data.index = index
            })

            this.pagesDescriptor.splice(index+1, 0, pageDescriptor);
            this.pagesDescriptor.forEach((pageDescriptor, index) => {
                pageDescriptor.index = index
            })
        },
        watchAuditReport(uid){
            this.$refs.waitingModal.open(`audit-report/${uid}/`);
        },
        prepareOverridableData() {
            let overriddenAuditData = {};
            let defaultAuditData = {};
            this.auditReport.config.forEach(config => {
                if (defaultAuditData[config.motor_name] === undefined) {
                    defaultAuditData[config.motor_name] = {};
                    defaultAuditData[config.motor_name].solutions_table = cloneDeep(this.auditReport.audit_data.motors[config.motor_name].solutions_table);
                }
                if (overriddenAuditData[config.motor_name] === undefined) {
                    overriddenAuditData[config.motor_name] = {};
                    if (this.auditReport.audit_data_overridden && this.auditReport.audit_data_overridden.motors && this.auditReport.audit_data_overridden.motors[config.motor_name]) {
                        overriddenAuditData[config.motor_name].solutions_table = cloneDeep(this.auditReport.audit_data_overridden.motors[config.motor_name].solutions_table);
                    } else {
                        overriddenAuditData[config.motor_name].solutions_table = cloneDeep(this.auditReport.audit_data.motors[config.motor_name].solutions_table);

                    }
                }
            })
            this.$set(this, 'overriddenAuditData', overriddenAuditData);
            this.$set(this, 'defaultAuditData', defaultAuditData);
        },
        onAudditReportReady (response, fromWaitingModal=true){
            if(fromWaitingModal === true || fromWaitingModal === undefined){
              this.$refs.waitingModal.resetData;
            }
            this.$set(this, 'auditReport', response.data);
            this.$set(this, 'securityCoeff', response.data.security_coeff || 0);
            this.$set(this, 'config', response.data.config || []);
            this.$set(this, 'pagesDescriptor', response.data.template.slice());
            this.$set(this.auditReport, 'report', response.data.report);
            this.prepareOverridableData()
            this.userDataAlreadySetted = this.auditReport.user_data.length > 0;
            // let userData = [];
            // if(this.auditReport.user_data.length != this.auditReport.template.length){
            //     userData = this.auditReport.user_data;
            //     userData = this.checkUserDataMAtchingTemplate(userData);
            // }else{
            //     for(let page of this.auditReport.template){
            //         userData.push(this.createPageUserData(page));
            //     }
            // }
            this.$set(this, 'userData', this.auditReport.user_data);
            this.showPdfs = true;
            if(fromWaitingModal === true || fromWaitingModal === undefined){
              this.$refs.waitingModal.close();
            }
        },
        createPageUserData (page){
            let initPageUserData = this.auditReport.user_data.find((user_data) => {
                user_data.index === page.index
            })
            let currentPageUserData = {
                data: initPageUserData ? initPageUserData.data : {},
                display: initPageUserData ? initPageUserData.display : true,
                index: page.index
            }
            for(let zoneName in page.text_zones){
                currentPageUserData.data[zoneName] = "";
            }
            return currentPageUserData;
        },
        checkUserDataMAtchingTemplate (userData){
            for(let page of this.auditReport.template){
                let relatedUserData = userData.find((userDataPage) => {
                    return userDataPage.index === page.index;
                });
                if(relatedUserData === undefined){
                    userData.push(this.createPageUserData(page));
                }
            }
            return userData;
        },
        onError (){
        },
        sendOverriddenValues() {
            this.showPdfs = false;
            this.fieldToWatch = 'prepare_status';
            let data = {
                item: {
                    audit_data_overridden: {motors: this.overriddenAuditData},
                    url: this.auditReport.url,
                    uid: this.auditReport.uid,
                    generate_status: 'WAITING',
                    prepare_status: 'PENDING'
                },
                model: 'auditReports',
            }
            this.$store.dispatch('patchItem', data).then((response) => {
                this.watchAuditReport(response.uid);
            });
        },
        sendChosenEngines(payload) {
            this.showPdfs = false;
            this.fieldToWatch = 'prepare_status';
            let data = {
                item: {
                    model_name: this.$route.params.modelName,
                    config: payload.solutions.map(item => {
                        return {
                            moteur: item.motor_uid,
                            motor_name: item.name,
                            rank: item.rank,
                            solution: item.solution
                        }
                    }),
                    security_coeff: this.securityCoeff,
                    audit_uid: this.$route.params.auditId,
                    generate_status: 'WAITING',
                    prepare_status: 'PENDING'
                },
                model: 'auditReports',
            }
            if (Object.keys(payload.overriddenAuditData).length) {
                data.item.audit_data_overridden = {
                    motors: payload.overriddenAuditData
                };
            }
            let method = 'patchItem';
            if (!this.$route.params.reportId) {
                method = 'createItem';
                data.url = this.$store.state.api.meta.listModels.auditReports.url
            } else {
                if (this.auditReport) {
                    data.item.url = this.auditReport.url
                } else {
                    data.item.url = `${window.config.api_root_url}/${this.$store.state.api.meta.listModels.auditReports.url}${this.$route.params.reportId}/`
                }
                data.item.uid = this.$route.params.reportId
            }
            this.$store.dispatch(method, data).then((response) => {
                this.watchAuditReport(response.uid);
            });
        },
        async saveReport() {
            this.loadingSave = true;
            return this.$store.dispatch('patchItem', {
                item: {
                    uid: this.auditReport.uid,
                    url: this.auditReport.url,
                    user_data: this.userData,
                    template: this.pagesDescriptor
                },
                model: 'auditReports',
            }).then(() => {
                this.$notify.success({
                    message: this.getText('audit_report_save_success')
                })
            }).catch(() => {
                this.$notify.error({
                    message: this.getText('audit_report_save_error')
                })
            }).finally(() => {
                this.loadingSave = false;
            });
        }
    },
};
</script>

<style lang="scss">
.report {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .actions-bar.sticky {
        position: sticky;
        top: 0;
        z-index: 2001;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .el-button+.el-button {
        margin-left: 0 !important;
    }
    .el-button {
        margin-bottom: 10px !important;
    }
    .action-wrapper {
        padding-bottom: 14px;
        display: flex;;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .greenButton {
            width: auto;
            &.disabled {
                cursor: not-allowed;
                background-color: #e6ec9b !important;
            }
        }
    }
    .nav-wrapper {
        padding-bottom: 14px;
    }
    .content {
        padding: 20px;
        position: relative;
        min-height: 200px;
        width: 100%;
    }

    .no-content{
        height: 300px;
        border: 5px dashed #cacaca;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 15px;
    }
    .generating-report {
        flex-grow: 1;
        .message {
            width: 90%;
            margin: 50px auto;
            text-align: center;
            font-size: 20px;
        }
    }
    .container {
        .save-icon {
            height: 18px;
            margin-right: 10px;
        }
    }
}
.tooltip-audit-report-save-warning {
    width: 200px;
}

</style>



// WEBPACK FOOTER //
// src/components/page/report/index.vue